import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicenseCodeService {
  constructor(private ws: PostmethodService) { }

  licenseCodeCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "licenceCodeMaster");
  }

  roleCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "roleMaster");
  }
}
